"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTouchErrors = exports.splitPathKey = exports.pathSelector = exports.deepTruthy = exports.deepAssign = exports.hasErrors = exports.capitalizeFirstLetter = void 0;
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function hasErrors(object) {
    if (Array.isArray(object)) {
        return object.some(hasErrors);
    }
    else if (typeof object === 'object' && object !== null) {
        return Object.values(object).some(hasErrors);
    }
    return !!object;
}
exports.hasErrors = hasErrors;
function deepAssign(state, key, value) {
    var _a, _b;
    var _c, _d, _e;
    var path = splitPathKey(key);
    if (path.length === 0 || (path.length === 1 && path[0] === '')) {
        return value;
    }
    var current = path[0], nextPath = path.slice(1);
    if (Array.isArray(state)) {
        var currentNumber = typeof current === 'string' ? parseInt(current) : current;
        var newArray = __spreadArray([], state, true);
        if (String(currentNumber) !== 'NaN') {
            newArray[currentNumber] = deepAssign((_c = state === null || state === void 0 ? void 0 : state[currentNumber]) !== null && _c !== void 0 ? _c : {}, nextPath, value);
        }
        return newArray;
    }
    if (typeof state === 'object' && state !== null) {
        var currentString = String(current);
        return __assign(__assign({}, state), (_a = {}, _a[currentString] = deepAssign((_d = state === null || state === void 0 ? void 0 : state[currentString]) !== null && _d !== void 0 ? _d : {}, nextPath, value), _a));
    }
    if (typeof state === 'undefined' || (typeof state === 'object' && state === null)) {
        var currentString = String(current);
        return _b = {},
            _b[currentString] = deepAssign((_e = state === null || state === void 0 ? void 0 : state[currentString]) !== null && _e !== void 0 ? _e : {}, nextPath, value),
            _b;
    }
    return state;
}
exports.deepAssign = deepAssign;
function deepTruthy(state) {
    if (Array.isArray(state)) {
        return state.some(deepTruthy);
    }
    if (!!state && typeof state === 'object') {
        return Object.values(state).some(deepTruthy);
    }
    return !!state;
}
exports.deepTruthy = deepTruthy;
function pathSelector(path, state) {
    return [state].concat(path).reduce(function (v, a) {
        if (!v) {
            return undefined;
        }
        if (typeof v === 'object' && a in v) {
            return v[a];
        }
        else if (Array.isArray(v) && typeof a === 'string' && parseInt(a) in v) {
            return v[parseInt(a)];
        }
        return undefined;
    });
}
exports.pathSelector = pathSelector;
function splitPathKey(key) {
    if (Array.isArray(key)) {
        return key;
    }
    if (typeof key === 'number') {
        return [key];
    }
    if (key === '') {
        return [];
    }
    return "".concat(key).split('.');
}
exports.splitPathKey = splitPathKey;
function getTouchErrors(errors, touches) {
    var target = {};
    for (var _i = 0, _a = Object.keys(touches); _i < _a.length; _i++) {
        var pathStr = _a[_i];
        var path = pathStr.split('.');
        var pathIndex = 0;
        var sourcePointer = errors;
        var targetPointer = target;
        while (pathIndex < path.length) {
            var pathElem = path[pathIndex];
            if (!targetPointer.hasOwnProperty(pathElem)) {
                if (pathIndex === path.length - 1) {
                    if (typeof (sourcePointer === null || sourcePointer === void 0 ? void 0 : sourcePointer[pathElem]) === 'undefined') {
                        targetPointer[pathElem] = undefined;
                    }
                    else {
                        targetPointer[pathElem] = JSON.parse(JSON.stringify(sourcePointer === null || sourcePointer === void 0 ? void 0 : sourcePointer[pathElem]));
                    }
                }
                else if (Array.isArray(sourcePointer === null || sourcePointer === void 0 ? void 0 : sourcePointer[pathElem])) {
                    targetPointer[pathElem] = [];
                }
                else {
                    targetPointer[pathElem] = {};
                }
            }
            targetPointer = targetPointer[pathElem];
            sourcePointer = sourcePointer === null || sourcePointer === void 0 ? void 0 : sourcePointer[pathElem];
            pathIndex++;
        }
    }
    return target;
}
exports.getTouchErrors = getTouchErrors;
//# sourceMappingURL=utils.js.map